function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 2,
  d: "M419.202,278.541 C409.478,267.76,389.636,256.557,359.807,257.182"
}));

var _ref4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#1"
});

var _ref5 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 4,
  d: "M267.782,352.231 C267.044,300.932,310.678,257.847,359.978,257.22"
}));

var _ref7 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#3"
});

var _ref8 = /*#__PURE__*/React.createElement("title", null, "Shape 4");

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 6,
  d: "M426.607,271.829 C434.485,280.855,422.972,294.847,411.766,285.203 C411.766,285.203,411.753,271.861,411.753,271.861 C411.753,271.861,426.609,271.834,426.609,271.834 C426.609,271.834,426.607,271.829,426.607,271.829 z"
}));

var _ref10 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#5"
});

var _ref11 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 8,
  d: "M363.701,315.346 C383.715,315.346,399.94,331.571,399.94,351.585 C399.94,371.599,383.715,387.823,363.701,387.823 C343.687,387.823,327.463,371.599,327.463,351.585 C327.463,331.571,343.687,315.346,363.701,315.346 z"
}));

var _ref13 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#7"
});

var _ref14 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 10,
  d: "M351.036,296.165 C351.036,296.165,375.9,296.165,375.9,296.165 C375.9,296.165,375.9,313.832,375.9,313.832 C375.9,313.832,351.036,313.832,351.036,313.832 C351.036,313.832,351.036,296.165,351.036,296.165 z"
}));

var _ref16 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#9"
});

var _ref17 = /*#__PURE__*/React.createElement("title", null, "Path Copy");

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 12,
  d: "M351.625,389.744 C351.625,389.744,376.49,389.744,376.49,389.744 C376.49,389.744,376.49,407.411,376.49,407.411 C376.49,407.411,351.625,407.411,351.625,407.411 C351.625,407.411,351.625,389.744,351.625,389.744 z"
}));

var _ref19 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#11"
});

var _ref20 = /*#__PURE__*/React.createElement("title", null, "Path Copy Copy");

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 14,
  d: "M311.955,322.731 C311.955,322.731,329.538,305.149,329.538,305.149 C329.538,305.149,342.03,317.641,342.03,317.641 C342.03,317.641,324.448,335.223,324.448,335.223 C324.448,335.223,311.955,322.731,311.955,322.731 z"
}));

var _ref22 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#13"
});

var _ref23 = /*#__PURE__*/React.createElement("title", null, "Path Copy Copy");

var _ref24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 16,
  d: "M331.617,398.687 C331.617,398.687,314.035,381.104,314.035,381.104 C314.035,381.104,326.527,368.612,326.527,368.612 C326.527,368.612,344.109,386.194,344.109,386.194 C344.109,386.194,331.617,398.687,331.617,398.687 z"
}));

var _ref25 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#15"
});

var _ref26 = /*#__PURE__*/React.createElement("title", null, "Path Copy Copy Copy");

var _ref27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 18,
  d: "M415.285,322.133 C415.285,322.133,397.703,304.551,397.703,304.551 C397.703,304.551,385.21,317.043,385.21,317.043 C385.21,317.043,402.793,334.626,402.793,334.626 C402.793,334.626,415.285,322.133,415.285,322.133 z"
}));

var _ref28 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#17"
});

var _ref29 = /*#__PURE__*/React.createElement("title", null, "Path Copy Copy Copy");

var _ref30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 20,
  d: "M395.623,398.089 C395.623,398.089,413.205,380.507,413.205,380.507 C413.205,380.507,400.713,368.015,400.713,368.015 C400.713,368.015,383.131,385.597,383.131,385.597 C383.131,385.597,395.623,398.089,395.623,398.089 z"
}));

var _ref31 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#19"
});

var _ref32 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 22,
  d: "M418.406,422.361 C408.682,433.142,388.839,444.346,359.011,443.721"
}));

var _ref34 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#21"
});

var _ref35 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 24,
  d: "M267.748,352.167 C268.263,402.088,309.882,443.214,359.181,443.841"
}));

var _ref37 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#23"
});

var _ref38 = /*#__PURE__*/React.createElement("title", null, "Shape 4");

var _ref39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 26,
  d: "M425.81,429.073 C433.688,420.048,422.176,406.056,410.97,415.7 C410.97,415.7,410.956,429.041,410.956,429.041 C410.956,429.041,425.812,429.068,425.812,429.068 C425.812,429.068,425.81,429.073,425.81,429.073 z"
}));

var _ref40 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#25"
});

var _ref41 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 28,
  d: "M440.802,327.698 C444.613,347.153,444.074,356.653,440.872,372.898"
}));

var _ref43 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#27"
});

var _ref44 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 30,
  d: "M457.107,311.273 C467.26,336.606,466.236,365.044,457.431,389.084"
}));

var _ref46 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#29"
});

var _ref47 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 32,
  d: "M472.947,295.734 C491.901,336.183,487.6,376.348,472.868,405.149"
}));

var _ref49 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#31"
});

var _ref50 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 34,
  d: "M468.417,297.873 C469.603,300.364,472.584,301.421,475.074,300.235 C477.565,299.049,478.622,296.069,477.436,293.578 C476.25,291.087,473.27,290.03,470.779,291.216 C468.289,292.402,467.231,295.383,468.417,297.873"
}));

var _ref52 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#33"
});

var _ref53 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 36,
  d: "M468.415,402.892 C467.166,405.349,468.145,408.353,470.602,409.601 C473.059,410.85,476.062,409.871,477.311,407.414 C478.56,404.957,477.58,401.953,475.124,400.705 C472.667,399.456,469.663,400.436,468.415,402.892"
}));

var _ref55 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#35"
});

var _ref56 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 38,
  d: "M452.726,387.355 C451.778,389.948,453.111,392.819,455.704,393.767 C458.297,394.715,461.167,393.381,462.115,390.788 C463.063,388.195,461.73,385.325,459.137,384.377 C456.544,383.429,453.674,384.762,452.726,387.355"
}));

var _ref58 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#37"
});

var _ref59 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 40,
  d: "M453.305,314.521 C455.102,316.618,458.259,316.862,460.356,315.065 C462.454,313.269,462.698,310.112,460.901,308.014 C459.104,305.916,455.947,305.673,453.85,307.469 C451.752,309.266,451.508,312.423,453.305,314.521"
}));

var _ref61 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#39"
});

var _ref62 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 42,
  d: "M436.305,329.872 C437.511,332.355,440.502,333.391,442.986,332.185 C445.47,330.98,446.505,327.988,445.3,325.505 C444.094,323.021,441.103,321.985,438.619,323.191 C436.135,324.397,435.099,327.388,436.305,329.872"
}));

var _ref64 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#41"
});

var _ref65 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 44,
  d: "M436.208,371.139 C435.245,373.715,436.553,376.584,439.129,377.547 C441.705,378.509,444.574,377.202,445.537,374.625 C446.499,372.049,445.191,369.18,442.615,368.218 C440.039,367.255,437.17,368.563,436.208,371.139"
}));

var _ref67 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#43"
});

var SvgCharlieTest = function SvgCharlieTest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "257.749pt",
    y: "247.157pt",
    width: "232.866pt",
    height: "206.683pt",
    viewBox: "257.749 247.157 232.866 206.683",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, _ref3, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 20
    }
  }))), _ref4, /*#__PURE__*/React.createElement("defs", null, _ref5, /*#__PURE__*/React.createElement("g", {
    id: 3
  }, _ref6, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 20
    }
  }))), _ref7, /*#__PURE__*/React.createElement("defs", null, _ref8, /*#__PURE__*/React.createElement("g", {
    id: 5
  }, _ref9, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref10, /*#__PURE__*/React.createElement("defs", null, _ref11, /*#__PURE__*/React.createElement("g", {
    id: 7
  }, _ref12, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f123",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 20
    }
  }))), _ref13, /*#__PURE__*/React.createElement("defs", null, _ref14, /*#__PURE__*/React.createElement("g", {
    id: 9
  }, _ref15, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#10",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref16, /*#__PURE__*/React.createElement("defs", null, _ref17, /*#__PURE__*/React.createElement("g", {
    id: 11
  }, _ref18, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#12",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref19, /*#__PURE__*/React.createElement("defs", null, _ref20, /*#__PURE__*/React.createElement("g", {
    id: 13
  }, _ref21, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#14",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref22, /*#__PURE__*/React.createElement("defs", null, _ref23, /*#__PURE__*/React.createElement("g", {
    id: 15
  }, _ref24, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#16",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref25, /*#__PURE__*/React.createElement("defs", null, _ref26, /*#__PURE__*/React.createElement("g", {
    id: 17
  }, _ref27, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#18",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref28, /*#__PURE__*/React.createElement("defs", null, _ref29, /*#__PURE__*/React.createElement("g", {
    id: 19
  }, _ref30, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#20",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref31, /*#__PURE__*/React.createElement("defs", null, _ref32, /*#__PURE__*/React.createElement("g", {
    id: 21
  }, _ref33, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#22",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 20
    }
  }))), _ref34, /*#__PURE__*/React.createElement("defs", null, _ref35, /*#__PURE__*/React.createElement("g", {
    id: 23
  }, _ref36, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#24",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 20
    }
  }))), _ref37, /*#__PURE__*/React.createElement("defs", null, _ref38, /*#__PURE__*/React.createElement("g", {
    id: 25
  }, _ref39, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#26",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref40, /*#__PURE__*/React.createElement("defs", null, _ref41, /*#__PURE__*/React.createElement("g", {
    id: 27
  }, _ref42, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#28",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 10
    }
  }))), _ref43, /*#__PURE__*/React.createElement("defs", null, _ref44, /*#__PURE__*/React.createElement("g", {
    id: 29
  }, _ref45, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#30",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 10
    }
  }))), _ref46, /*#__PURE__*/React.createElement("defs", null, _ref47, /*#__PURE__*/React.createElement("g", {
    id: 31
  }, _ref48, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#32",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 10
    }
  }))), _ref49, /*#__PURE__*/React.createElement("defs", null, _ref50, /*#__PURE__*/React.createElement("g", {
    id: 33
  }, _ref51, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#34",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref52, /*#__PURE__*/React.createElement("defs", null, _ref53, /*#__PURE__*/React.createElement("g", {
    id: 35
  }, _ref54, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#36",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref55, /*#__PURE__*/React.createElement("defs", null, _ref56, /*#__PURE__*/React.createElement("g", {
    id: 37
  }, _ref57, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#38",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref58, /*#__PURE__*/React.createElement("defs", null, _ref59, /*#__PURE__*/React.createElement("g", {
    id: 39
  }, _ref60, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#40",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref61, /*#__PURE__*/React.createElement("defs", null, _ref62, /*#__PURE__*/React.createElement("g", {
    id: 41
  }, _ref63, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#42",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref64, /*#__PURE__*/React.createElement("defs", null, _ref65, /*#__PURE__*/React.createElement("g", {
    id: 43
  }, _ref66, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#44",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref67);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCharlieTest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/charlieTest.e32a7985.svg";
export { ForwardRef as ReactComponent };